import { UntypedFormGroup, ValidatorFn } from '@angular/forms';

/**
 * The purpose of this validator is to check required checkboxes are checked
 * For example, we need 2 checkboxes checked from passed from group then until 2 checkboxes are checked this validator will return requireCheckboxesToBeChecked to true(invalid).
 *
 * @param minRequired - Require checkboxes to be checked. Default requirement is 1.
 */
export function requireCheckboxesToBeCheckedValidator(minRequired = 1): ValidatorFn {
  return function validate(formGroup: UntypedFormGroup) {
    let checked = 0;

    // count checked checkboxes
    Object.keys(formGroup.controls).forEach((key) => {
      const control = formGroup.controls[key];

      if (control.value === true) {
        checked += 1;
      }
    });

    // If our minimum number of checkboxes hasn't been met, return true (invalid)
    if (checked < minRequired) {
      return {
        requireCheckboxesToBeChecked: true,
      };
    }

    return null;
  };
}
